module.exports = __webpack_public_path__ + "media/images/fallback/product_facebook-8ca81ad5c88e9d248a105c9791fe000c.webp";